module.exports = __webpack_public_path__ + "204a15b5685f1c6a6631cf92e92a4710.svg";